import {useMappedState} from 'redux-react-hook'
import {convertList, sortList, convertType} from 'utils/convertData'
import {formatNumber} from 'utils/format'

function useTradeHistory (symbolInfo) {
  const mapState = state => ({
    data: state?.orders?.tradeHistories || {},
    hasMore: state?.orders?.tradeHistoriesHasMore
  })
  const {hasMore, data: tradeHistoryEntity} = useMappedState(mapState)
  const tradeHistories = Object.values(tradeHistoryEntity)
  const {
    pricePrecision, quantityPrecision, lng, quoteAsset
  } = symbolInfo

  return {
    hasMore,
    data: sortList(convertList(Object.values(tradeHistories)))?.map(v => ({
      ...v,
      side: (
        <span style={{color: v.side === 'BUY' ? '#00c582' : '#ff0371'}}>
          {convertType(lng, v.side)}
        </span>
      ),
      price: formatNumber(v.price, pricePrecision),
      qty: formatNumber(v.qty, quantityPrecision),
      fee: `${formatNumber(v.fee, pricePrecision)} ${quoteAsset}`,
      realizedProfit: `${formatNumber(v.realizedProfit, pricePrecision)} ${quoteAsset}`
    }))
  }
}

export default useTradeHistory
